import { IAppMenu, IAppRoutes, IAppSubMenu } from '@pf/shared-ui';

import { UserPermissionCheckService } from '@pf/shared-services';
import { firstValueFrom } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export abstract class PlatformRoutes
    extends RoutePathBuilder
    implements IAppRoutes
{
    userPermissionCheckService = inject(UserPermissionCheckService);
    navigation: IAppMenu[] = [];

    error() {
        return this.url('error');
    }

    protected setupNavigation() {
        this.checkAllMenuItemsForPermission(this.getAllMenuItems()).then(
            nav => (this.navigation = nav)
        );
    }

    private async checkAllMenuItemsForPermission(menuItems: IAppMenu[]) {
        return await Promise.all(
            menuItems.map(async item => {
                const checkedMenuItem = (await this.checkPermissionGranted(
                    item,
                    this.userPermissionCheckService
                )) as IAppMenu;
                if (item.subMenu) {
                    checkedMenuItem.subMenu = await Promise.all(
                        item.subMenu.map(
                            async subItem =>
                                (await this.checkPermissionGranted(
                                    subItem,
                                    this.userPermissionCheckService
                                )) as IAppSubMenu
                        )
                    );
                }
                return checkedMenuItem;
            })
        );
    }

    private async checkPermissionGranted(
        item: IAppMenu | IAppSubMenu,
        permissionCheckService: UserPermissionCheckService
    ) {
        if (!item.permissions?.length) {
            item.hide = false;
            return item;
        }

        const hasPermission = await firstValueFrom(
            permissionCheckService.hasOneOfPermissions$(item.permissions)
        );
        if (!hasPermission) {
            item.hide = true;
        }

        return item;
    }

    protected abstract getAllMenuItems(): IAppMenu[];
}
